

require('uiUtils');

var _squid = require('squid');

require('xo-form-components/src/zipcode/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCep', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sidebar: '=?',
            prefillAddress: '=?',
            doneFn: '=?'
        },
        controller: ['$scope', function ($scope) {
            $scope.country = _squid.$locale.country;
            $scope.address = {};
            $scope.onSubmit = function () {
                $scope.prefillAddress.address = {
                    country: _squid.$locale.country,
                    postal_code: $scope.address.postal_code
                };
                return $scope.prefillAddress.save({
                    data: $scope.prefillAddress,
                    success: function success(result) {
                        $scope.prefillAddress.address = result;
                        $scope.doneFn();
                    }
                });
            };
        }]
    };
});

_squid.$locale;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/addCep/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-card/addCep/directive.js
// module chunks = 0